export const ModuleIdMappingProd = {
  PUBLIC_MODULE_ID: 'PUBLIC_MODULE_ID',
  UPLOAD_PRICING_ID: '569f1167-4472-429d-a38c-995b23979d1d',
  PRICING_SUMMARY_ID: '2a230d00-93c1-4266-bbb8-b92a51af89bd',
  APPROVALS_ID: '695e404b-1818-4e04-a813-2c2d9cf5eff2',
  BULK_PO_CREATION: '7c8a6738-d72a-476f-83b7-32a43b68e01f',
  PO_SUMMARY_ID: '040ec22f-8c25-45b3-bc7d-e6aecbdd5494',
  ASN_ID: 'ab186f94-0d1d-4fb1-baef-63061d822f7d',
  PO_MANAGEMENT_ID: '2662d315-8f87-4335-9f51-dc07df295111',
  SKU_PRICE_SUGGESTIONS_ID: '939c4bd6-75ac-4322-8e3b-04cd22bbcb21',
  BUNDLE_PRICE_SUGGESTIONS_ID: '1f8d89f3-65db-400e-ac26-c26e747461db',
  SKU_ID: '0ea3bea3-932c-47f3-a561-0503a8fe8711',
  BUNDLE_LIVE_PRICING_ID: 'fd697579-1264-496f-8a54-9d924f7f11d4',
  USER_MANAGEMENT_ID: '1ba76d63-82a1-42a7-851b-0fdf6c7cd73f',
  REPORTS_ID: '667b6648-fbce-4645-90ea-679c839ab808',
  ENTITY_MANAGEMENT: '9dcd74f2-64d1-4ef0-8aa0-275d1d8678d8',
  PRICING_ID: 'b46f73e6-7a57-4e08-b09c-51f6384a1eeb',
  SKU_LIVE_PRICING_ID: 'd5a0f080-16ab-4110-8e4d-b54de6060780',
  BULK_JOBS_ID: '9f1e70f1-d650-4de4-9b9c-dc3128ab55bf',
  PO_REPORTS_ID: '20e29a1b-e7dd-46dc-8e64-041384043d92',
  PO_APPROVALS_ID: 'ba6c93e9-a586-4340-8847-c154e0970c98',
  RETURN_PO_ACKNOWLEDGEMENT_ID: 'fbf16ab7-3502-4af9-9d16-af7acb2e239e',
};
